export const SUPPORTED_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/svg+xml',
]);

export const ACCEPTED_IMAGE_TYPES = '.jpg,.jpeg,.png,.webp,.gif,.svg';

export function isSupportedImageType(file) {
  return SUPPORTED_IMAGE_TYPES.has(file.type);
}

export function createImageId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(`Failed to read ${file.name}`));
    reader.readAsDataURL(file);
  });
}

export function loadImageDetails(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve({
        width: image.naturalWidth || 0,
        height: image.naturalHeight || 0,
      });
    };
    image.onerror = () => reject(new Error('Failed to load image preview'));
    image.src = src;
  });
}

export function normalizeStoredImages(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images
    .filter((image) => image && image.src)
    .map((image) => ({
      id: image.id || createImageId(),
      name: image.name || 'Uploaded image',
      src: image.src,
      previewSrc: image.previewSrc || null,
      alt: image.alt || '',
      type: image.type || 'image/png',
      width: image.width || null,
      height: image.height || null,
      driveFileId: image.driveFileId || null,
      storageProvider: image.storageProvider || null,
    }));
}
